module.exports = __webpack_public_path__ + "img/swift-sport-color.4a8515de.svg";